import { render, staticRenderFns } from "./CompanySettingsLoyaltyProgram.vue?vue&type=template&id=f626fb6a&scoped=true"
import script from "./CompanySettingsLoyaltyProgram.vue?vue&type=script&lang=js"
export * from "./CompanySettingsLoyaltyProgram.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsLoyaltyProgram.vue?vue&type=style&index=0&id=f626fb6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626fb6a",
  null
  
)

export default component.exports